/**
 * Constructor method for creating instance of the (Top-level) header nav used for managing the
 * state of the active navigation items when the keyboard is used for navigation
 *
 * Instance properties
 * - domNode : reference to domNode
 * - headerNavItems : list of all navItems within the top-level header nav
 * - firstChars : inventory of firstChars for identifying elements based on keypress
 * - firstItem : first headerNavItem within the nav
 * - lastItem : last headerNavItem within the nav
 * - hasFocus : flag to identify current focus
 * - hasHover : flag to identify current hover
 *
 * @param {Node} domNode DomNode for the header nav
 */
const HeaderNav = function (domNode) {
  this.domNode = domNode;

  this.headerNavItems = []; // See HeaderNav init method
  this.firstChars = []; // See HeaderNav init method

  this.firstItem = null; // See HeaderNav init method
  this.lastItem = null; // See HeaderNav init method

  this.hasFocus = false; // See HeaderNav handleFocus, handleBlur
  this.hasHover = false; // See HeaderNav handleMouseover, handleMouseout
};

/*
 * Initializer for a HeaderNav instance
 *
 * Locate all navigation items (HeaderNavItems) within the HeaderNav which will be used
 * for activating the available subNav and external links. Push these items into a list and
 * set the first/last items in the list
 *
 */
HeaderNav.prototype.init = function () {
  let headerNavItem, textContent, numItems;

  // Get all elements for the headerNav which have dropdowns
  const headerNavItemsList = this.domNode.querySelectorAll(
    ":scope li.nav-item > a"
  );

  for (let i = 0; i < headerNavItemsList.length; i++) {
    headerNavItem = new HeaderNavItem(headerNavItemsList[i], this);
    headerNavItem.init();
    this.headerNavItems.push(headerNavItem);
    textContent = headerNavItemsList[i].textContent.trim();
    this.firstChars.push(textContent.substring(0, 1).toLowerCase());
  }

  numItems = this.headerNavItems.length;
  if (numItems > 0) {
    this.firstItem = this.headerNavItems[0];
    this.lastItem = this.headerNavItems[numItems - 1];
  }
  this.firstItem.domNode.tabIndex = 0;
};

/** FOCUS METHODS */

HeaderNav.prototype.setFocusToItem = function (newItem) {
  let flag = false;

  for (let i = 0; i < this.headerNavItems.length; i++) {
    let headerNavItem = this.headerNavItems[i];

    if (headerNavItem.domNode.tabIndex == 0) {
      flag = headerNavItem.domNode.getAttribute("aria-expanded") === "true";
    }

    headerNavItem.domNode.tabIndex = -1;
    if (headerNavItem.headerSubNav) {
      headerNavItem.headerSubNav.close();
    }
  }

  newItem.domNode.focus();
  newItem.domNode.tabIndex = 0;

  if (flag && newItem.headerSubNav) {
    newItem.headerSubNav.open();
  }
};

HeaderNav.prototype.setFocusToFirstItem = function () {
  this.setFocusToItem(this.firstItem);
};

HeaderNav.prototype.setFocusToLastItem = function () {
  this.setFocusToItem(this.lastItem);
};

HeaderNav.prototype.setFocusToPreviousItem = function (currentItem) {
  let index;

  if (currentItem === this.firstItem) {
    newItem = this.lastItem;
  } else {
    index = this.headerNavItems.indexOf(currentItem);
    newItem = this.headerNavItems[index - 1];
  }

  this.setFocusToItem(newItem);
};

HeaderNav.prototype.setFocusToNextItem = function (currentItem) {
  let index;

  if (currentItem === this.lastItem) {
    newItem = this.firstItem;
  } else {
    index = this.headerNavItems.indexOf(currentItem);
    newItem = this.headerNavItems[index + 1];
  }

  this.setFocusToItem(newItem);
};

HeaderNav.prototype.setFocusByFirstCharacter = function (currentItem, char) {
  let start,
    index,
    lowerChar = char.toLowerCase();

  // Get start index for search based on position of currentItem
  start = this.headerNavItems.indexOf(currentItem) + 1;
  if (start === this.headerNavItems.length) {
    start = 0;
  }

  // Check remaining slots in the menu
  index = this.getIndexFirstChars(start, lowerChar);

  // If not found in remaining slots, check from beginning
  if (index === -1) {
    index = this.getIndexFirstChars(0, lowerChar);
  }

  // If match was found...
  if (index > -1) {
    this.setFocusToItem(this.headerNavItems[index]);
  }
};

HeaderNav.prototype.getIndexFirstChars = function (startIndex, char) {
  for (let i = startIndex; i < this.firstChars.length; i++) {
    if (char === this.firstChars[i]) {
      return i;
    }
  }
  return -1;
};

window.addEventListener("load", function () {
  const headerNav = new HeaderNav(
    document.getElementById("desktop-header-nav")
  );

  headerNav.init();
});
